
import { useNavigate } from "react-router-dom";
import { theme } from "../theme.js";
import Button from "./base/Button.jsx";
import Card from "./base/Card.jsx";
import { DEFAULT_IMAGE } from "../utils/constants.js";

export default function RaceCard({ bib, count, bibs }) {

  const race = bib.race || {};
  const event = race.event || {};
  const id = bib.id_bdd ;
  const title = race.name || "Untitled race";
  const location = event.location || "Unknown location";
  const start = race.date
    ? new Date(race.date).toLocaleString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
    : "Date TBD";
  const organizer = (event.organizer && (event.organizer.name || event.organizer)) || "Organizer";


   const navigate = useNavigate();

   const handleCardClick = (e) => {
     // If clicked from a parent that passed multiple bibs, include their ids
     const ids = (bibs && Array.isArray(bibs)) ? bibs.map(b => b.id_bdd || b.id) : [id];
     navigate(`/tickets/${id}`, { state: { bib, bibIds: ids, bibs } });
   };

  return (
    <Card id={id} onClick={handleCardClick} style={{ display: "flex", flexDirection: "row" }}>
      <div style={styles.imageContainer}>
        {race.image ? (
          <img src={race.image} alt={title} style={styles.image} />
        ) : (
          <img src={DEFAULT_IMAGE} alt={title} style={styles.image} />
        )}
        {!bib.registration_complete && (
          <div style={styles.incompleteIndicator}>
            Inscription Incomplète
          </div>
        )}
      </div>
      <div style={styles.cardContent}>
        <h3 style={styles.raceName}>{title}</h3>
        <div style={styles.datePrice}>
          <span style={styles.date}>{start}</span>
        </div>
        <div style={styles.footer}>
            <Button 
              onClick={handleCardClick}
              title="Voir les détails"
            />
        </div>
      </div>
    </Card>
  );
}

const styles = {
  imageContainer: {
    backgroundColor: theme.colors.bgLight,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    borderBottom: `1px solid ${theme.colors.border}`,
    overflow: "hidden",
    height: "220px",
    position: "relative",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  incompleteIndicator: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: theme.fonts.size.base,
    fontWeight: theme.fonts.weight.semibold,
    textAlign: "center",
    padding: theme.spacing.md,
  },
  cardContent: {
    backgroundColor: theme.colors.bgLight,
    padding: theme.spacing.lg,
    display: "flex",
    flexDirection: "column",
    flex: 1,
    width: "100%",
    justifyContent: "flex-start",
  },
  raceName: {
    fontSize: theme.fonts.size.base,
    fontWeight: theme.fonts.weight.bold,
    color: theme.colors.textInverted,
    margin: `0 0 ${theme.spacing.xs} 0`,
  },
  location: {
    fontSize: theme.fonts.size.sm,
    color: theme.colors.textMuted,
    margin: `0 0 ${theme.spacing.md} 0`,
  },
  info: {
    display: "flex",
    gap: theme.spacing.xs,
    marginBottom: theme.spacing.md,
  },
  distance: {
    fontSize: theme.fonts.size.xs,
    backgroundColor: theme.colors.bgLight,
    color: theme.colors.textInverted,
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    borderRadius: theme.radius.full,
    fontWeight: theme.fonts.weight.medium,
  },
  datePrice: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xs,
    fontSize: theme.fonts.size.xs,
    color: theme.colors.textMuted,
    marginBottom: theme.spacing.md,
  },
  date: {
    fontWeight: theme.fonts.weight.medium,
    color: theme.colors.textInverted,
  },
  time: {
    color: theme.colors.textLight,
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "auto",
    paddingTop: theme.spacing.md,
    borderTop: `1px solid ${theme.colors.border}`,
  },
  price: {
    fontSize: "20px",
    fontWeight: theme.fonts.weight.bold,
    color: theme.colors.text,
  }
};